// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/components/CustomComponents/SalesPartyDetails.css
// module id = ./src/components/CustomComponents/SalesPartyDetails.css
// module chunks = 3